import configure from "./configure.json";
import dashboard from "./dashboard.json";
const translations = {
    configure,
    dashboard
  };
  
  export default translations;